var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"icon icon-sm float-right",attrs:{"src":"https://cdn.purplewave.ai/legacy/close.svg"},on:{"click":function($event){return _vm.$emit('close')}}}),_c('small',[_vm._v(" Répondre à "),_c('strong',[_vm._v(_vm._s(_vm.toUser))]),_vm._v("...")]),_c('br'),_c('small',[_c('em',[_vm._v(_vm._s(_vm.toText))])]),_c('br'),_c('br')])
}
var staticRenderFns = []

export { render, staticRenderFns }